// @ts-nocheck

import { filter } from 'lodash';
import { createSelector } from 'reselect';

import { selectBasketSystems } from '../../selectors/basket/basketPrimary.selector';
import { selectBasketNbBetsSystem } from '../../selectors/basketCommon.selector';

const getReadOnlyFromProps = (_, props) => props.readOnly;

const selectBasketCombinationsSelectorProps = createSelector(
  [selectBasketSystems, selectBasketNbBetsSystem, getReadOnlyFromProps],
  (systems, nbBets, readOnly) => {
    const combinations = filter(systems, (x) => (readOnly ? x.checked === true : true)).map((system) => {
      const { k, title, count, checked } = system;
      return {
        id: k,
        label: title,
        counter: count,
        selected: checked === true,
      };
    });

    return {
      combinations,
      nbBets,
    };
  },
);

export default selectBasketCombinationsSelectorProps;
